const NAME = 'banner';

export { NAME };
